import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useUIConfig } from '../../../contexts/UIConfigContext';
import { useAddTableRow, type AddRowTableRef } from '../hooks/useAddTableRow';
import styles from '../../../styles/components/ResizableTableContainer.module.scss';

interface EmptyAddRowOverlayProps {
  /** Ref на смонтированный Handsontable — именно в него вставляется строка. */
  tableRef: AddRowTableRef;
  /** Сообщение пустого состояния (тот же emptyMessage, что у TrackedTable). */
  message: React.ReactNode;
  /** Подпись кнопки; по умолчанию — из UI Config (`add_row`). */
  label?: string;
  onRowAdded?: (rowIndex: number) => void;
}

/**
 * Пустое состояние таблицы, из которого можно создать первую строку.
 *
 * Рисуется поверх пустой сетки (шапка колонок видна), а не вместо неё:
 * Handsontable обязан быть смонтирован, иначе `hot.alter()` некуда применить —
 * именно из-за подмены сетки заглушкой кнопка «+» раньше молча ничего не делала.
 */
export const EmptyAddRowOverlay: React.FC<EmptyAddRowOverlayProps> = ({
  tableRef,
  message,
  label,
  onRowAdded,
}) => {
  const { getButtonText } = useUIConfig();
  const handleAddRow = useAddTableRow(tableRef, onRowAdded);

  return (
    <div className={styles.emptyOverlay}>
      <div className={styles.emptyOverlayCard}>
        <div className={styles.emptyOverlayText}>{message}</div>
        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={handleAddRow}>
          {label ?? getButtonText('add_row', 'Добавить строку')}
        </Button>
      </div>
    </div>
  );
};
